/**
 * Commercial name: SEO-Presta
 * Proprietary-license whose copyright belongs to the Licensor PRESTA MODULE, a company registered under French law
 * under the number 528 531 767, located 90 rue Stanislas Torrents 13006 Marseille
 * support@presta-module.com https://www.presta-module.com
 *
 * SEO-Presta’ source codes are protected and Licensees are not allowed to create any Derivated Work.
 * The distribution or resale of SEO-Presta is strictly forbidden.
 *
 * SEO-Presta shall be used for Licensees’ own use, which allows Customization.
 *
 * Licensees shall not distribute nor resale publicly any Customization of SEO-Presta. However, Licensees are allowed
 * to sale a customization of SEO-Presta as part of a service provided to a designated customer.
 *
 * Limitation of Liability: Under no circumstances and under no legal theory, whether in tort (including negligence),
 * contract, or otherwise, shall the Licensor be liable to anyone for any indirect, special, incidental, or
 * consequential damages of any character arising as a result of this License including, without limitation, damages
 * for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages
 * or losses. This limitation of liability shall not apply to the extent applicable law prohibits such limitation.
 *
 * Attribution notice: SEO-Presta is a Derivated Work from an Original Work created by PrestaShop SA
 * and its contributors which can be found at https://github.com/PrestaShop/PrestaShop
 */

const getQueryParameters = params => params.split('&').map((str) => {
    const [key, val] = str.split('=');
    return {
        name: key,
        value: decodeURIComponent(val).replace(/\+/g, ' '),
    };
});

export default getQueryParameters;
